var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "view-document-detail",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "row body-main-row"
  }, [_c('div', [_vm.skeletonLoader ? _c('b-skeleton-table', {
    attrs: {
      "rows": 15,
      "columns": 1,
      "table-props": {
        bordered: _vm.none,
        striped: true
      }
    }
  }) : _vm._e(), !_vm.skeletonLoader ? _c('div', {
    staticClass: "document-view-body"
  }, [_c('p', [_c('img', {
    staticClass: "elevate-logo",
    attrs: {
      "src": require("@/assets/images/darknuera.png")
    }
  })]), _c('div', {
    staticClass: "directory-block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.data.user_info.first_name) + " " + _vm._s(_vm.data.user_info.last_name))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.data.user_info.address1))]), _c('li', [_vm._v(_vm._s(_vm.data.user_info.city) + ", " + _vm._s(_vm.data.user_info.state) + " " + _vm._s(_vm.data.user_info.zip))])])]), _vm.data.is_nawu ? _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("December 1st , 2023")]) : _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("November 29th, 2024")]), _c('p', [_c('strong', [_vm._v("Dear Valued Member,")])]), _c('div', [_c('p', [_vm._v("As of January 1st, 2025, the "), _c('strong', [_vm._v(_vm._s(_vm.data.plan_name))]), _vm._v(" will be renewed. There is nothing you need to do on your end as the renewal is automatic. This is just a formal notification of the rate change for 2025.")]), _c('p', [_vm._v("Billing will be adjusted accordingly on your upcoming Statement or Electronic Payment (EFT).")]), _c('br'), _c('p', [_c('strong', [_vm._v("Your new rate for your benefit plan as of January 1st, 2025 will be as follows:")])])]), _vm.updatedPlans.length ? _c('div', _vm._l(_vm.updatedPlans, function (plan, index) {
    return _c('div', {
      key: index,
      staticClass: "new-rate-details"
    }, [_c('ul', [_c('li', [_vm._v("Plan: "), _c('strong', [_vm._v(_vm._s(plan.planName))])]), _c('li', [_vm._v("Tier: "), _c('strong', [_vm._v(_vm._s(plan.tierInfo))])]), _c('li', [_vm._v("New Rate: "), _c('strong', [_vm._v("$" + _vm._s(plan.newRate))])])])]);
  }), 0) : _vm._e(), _c('p', [_c('span', [_vm._v("Broker: "), _c('b', [_vm._v(_vm._s(_vm.data.agent_name))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "14%"
    }
  }, [_vm._v("Phone : "), _c('b', [_vm._v(_vm._s(_vm.data.agent_phone))])])]), _c('br'), _c('div', {
    staticClass: "doc-footer"
  }, [_c('p', [_c('strong', [_vm._v("Sincerely,")])]), _c('p', {
    staticClass: "osf"
  }, [_vm._v("NuEra Billing Services")])])]) : _vm._e()], 1)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }